import {
    AdminUserCreateRequest,
    LanguageCode,
    Post,
    Gallery,
    ImageFile,
    SiteDataContext,
    UserDataContext
} from "./Models";

export class Constants {
    public static get defaultUserContext(): UserDataContext {
        return {
            id: 0,
            displayName: "",
            email: "",
            isSuperAdmin: false,
            isPasswordTemporary: false,
            websites: [],
        }
    }

    public static get defaultSiteContext(): SiteDataContext {
        return {
            id: -1,
            domainName: "",
            shortName: "",
            settings: {usesPost: false, usesGallery: false},
        }
    }

    public static defaultPost(siteContext: SiteDataContext, languageCode: LanguageCode = 'sk'): Post {
        return {
            id: 0,
            translations: [{
                headline: "",
                description: "",
                htmlText: "",
                languageShortcut: languageCode,
                postId: 0,
                isDefault: true
            }],
            link: "",
            gallery: null,
            websiteId: siteContext.id,
            createdAt: "",
            state: 'Published'
        }
    }

    public static defaultGallery(websiteId: number): Gallery {
        return {
            id: 0,
            title: "",
            websiteId: websiteId,
            titleImage: null,
            coordinates: null,
            galleryImages: [],
            visibility: 'Public',
        }
    }

    public static defaultImage(): ImageFile {
        return {
            id: 0,
            file: null,
            filePath: "",
            alt: "",
            createdAt: "",
            createdById: 0,
        }
    }

    public static get defaultAdminUserCreateRequest(): AdminUserCreateRequest {
        return {
            displayName: "",
            email: "",
            password: null, // DO NOT CHANGE TO '' !!
            isSuperAdmin: false,
            isPasswordTemporary: false,
            websiteIds: [],
        }
    }
}